import type { ExtraSection } from '@order-pilot/shared';

/**
 * One section as CSV text. Cells that start with `= + - @` are prefixed with a
 * quote so a spreadsheet never runs a till-supplied note as a formula; money
 * stays the API's exact digits.
 */
export function sectionToCsv(section: ExtraSection): string {
  const escape = (value: string | number | null): string => {
    let text = value === null ? '' : String(value);
    if (/^[=+\-@\t\r]/.test(text) && !/^-?\d+(\.\d+)?$/.test(text)) text = `'${text}`;
    return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
  };
  const lines = [section.columns.map((c) => escape(c.label)).join(',')];
  for (const row of section.rows) {
    lines.push(section.columns.map((c) => escape(row[c.key] ?? null)).join(','));
  }
  return lines.join('\r\n');
}

/** Save text as a file from the browser. */
export function downloadText(filename: string, text: string): void {
  const blob = new Blob(['﻿', text], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
